module.exports = __webpack_public_path__ + "img/sp-recent-works.f91f1e16.png";